import { palettes } from '@backstage/theme';
import type { PageTheme } from '@backstage/theme';

// Header/banner das páginas: fundo quase-sólido (#1a1717) com um glow radial
// MUITO sutil no canto superior direito, em vez do gradiente diagonal +
// shape "wave" default do Backstage (Material 2015 demais). Montado à mão
// (não via genPageTheme) porque o objetivo é justamente abandonar o
// combo gradiente+máscara — PageTheme só exige colors/shape/backgroundImage/
// fontColor, então um `shape: 'none'` com um único radial-gradient já
// satisfaz o contrato. getPageTheme cai em `home` pra qualquer themeId não
// mapeado aqui, então um único entry cobre todas as páginas.
const lightHeader: PageTheme = {
  colors: ['#1a1717', '#59110b'],
  shape: 'none',
  backgroundImage:
    'radial-gradient(circle at top right, rgba(89, 17, 11, 0.35), transparent 60%), #1a1717',
  fontColor: '#ffffff',
};
const darkHeader: PageTheme = {
  colors: ['#1a1717', '#89261e'],
  shape: 'none',
  backgroundImage:
    'radial-gradient(circle at top right, rgba(137, 38, 30, 0.3), transparent 60%), #1a1717',
  fontColor: '#ffffff',
};

export const lightPageTheme = { home: lightHeader };
export const darkPageTheme = { home: darkHeader };

const navigation = {
  background: '#1a1717',
  indicator: '#db2328',
  color: palettes.light.navigation.color,
  selectedColor: '#f07575',
};

export const lightPalette = {
  ...palettes.light,
  background: { default: '#ffffff', paper: '#f6f6f6' },
  primary: { main: '#db2328' },
  secondary: { main: '#4f3bb2' },
  text: { primary: '#1a1717' },
  link: '#db2328',
  navigation,
};

export const darkPalette = {
  ...palettes.dark,
  background: { default: '#1a1717', paper: '#2c2929' },
  primary: { main: '#f07575' },
  secondary: { main: '#b1a8e0' },
  link: '#f07575',
  navigation,
};
